import Button from "../components/Button";

const buttonHelper = {
  getButtons: function (buttonItems, buttonsPositioning, menu) {
    return buttonItems.length
      ? buttonItems.map((item, index) => {
          return (
            <Button
              align={item?.align}
              buttonClasses={item?.buttonClasses}
              buttonColor={item?.buttonColor}
              buttonLarge={item?.buttonLarge}
              buttonsPositioning={
                buttonItems[index + 1] ? buttonsPositioning : null
              }
              contentBefore={item?.ContentBefore}
              filled={item?.filled === null ? true : item?.filled}
              key={index}
              menu={menu}
              news={item?.news}
              page={item?.page}
              concert={item?.concert}
              course={item?.course}
              targetBlank={item?.targetBlank}
              text={item?.text}
              url={item?.url}
              withinContainer={item?.withinContainer}
            />
          );
        })
      : "";
  },
  // one level inheritance TODO: make multilevel
  buttonPageUrl: function (page, delimiter = " ", pathArray = []) {
    if (!page.data) return page;
    let buttonPageUrlArray = page.data.attributes.title.split(delimiter);
    buttonPageUrlArray.map((item, index) => {
      pathArray[index] = item.toLowerCase();
    });
    const linkValue = `/${pathArray.join("-")}`;
    return linkValue;
  },

  /**
   * Recursively collect all parent pages and return the slug path
   * @param {*} menu full menu object
   * @param {*} searchTitle search is based on MenusItem title for related pages
   * @param {*} prefix initial value is '/' - give yours for different routes
   * @returns
   */
  findSlugPath: function (menu, searchTitle, prefix = "/") {
    const searchInArray = (array, title) => {
      for (let item of Array.from(array)) {
        if (
          item.attributes.title.toLowerCase() === title?.toLowerCase() ||
          item.attributes?.slug === title?.toLowerCase()
        ) {
          return [item.attributes.slug];
        }
        if (
          item.attributes.children.data &&
          item.attributes.children.data.length > 0
        ) {
          const result = searchInArray(item.attributes.children.data, title);
          if (result) {
            return [item.attributes.slug].concat(result);
          }
        }
      }
      return null;
    };
    if (searchTitle === "Home") return "/";
    const result = searchInArray(menu, searchTitle);
    return result ? prefix + result.join("/") : null;
  },
  getLink: (button, menu) => {
    if (!button) return "#";

    const mappings = {
      page: () =>
        buttonHelper.findSlugPath(menu, button.page.data.attributes.title),
      news: () => `/about-us/news/${button.news.data.attributes?.slug ?? "#"}`,
      concert: () => `/concert/${button.concert.data.attributes?.slug ?? "#"}`,
      course: () => `/course/${button.course.data.attributes?.slug ?? "#"}`,
    };

    for (const key in mappings) {
      if (button[key]?.data) {
        return mappings[key]();
      }
    }

    return "#";
  },
};
export default buttonHelper;
